export const useRemoveMaskPhone = (phone: string) => {
    const formated1 = phone.replace("(", "");
    const formated2 = formated1.replace(")", "");
    const formated3 = formated2.replace("-", "");

    return formated3;
};
